/* eslint-disable no-invalid-this */
const { ArgumentOutOfRangeException } = require('exceptions');


class Stack {
    constructor() {
        this.current = null;
    }

    /**
     * @description Creates a new named stack.
     *
     * @param {Symbol} stackName Stack identifier/name.
     *
     * @memberof Stack
     *
     * @return {Array} A new stack.
     */
    createNewNamedStack = stackName => {
        if (typeof stackName !== 'symbol') {
            throw new ArgumentOutOfRangeException('stackName');
        }

        const stack = [];
        this[stackName] = stack;
        this.current = stack;

        return stack;
    };

    /**
     * @description Delete all stacks and reset to `null` current pointer.
     *
     * @memberof Stack
     */
    clear = () => {
        Object.getOwnPropertySymbols(this).forEach(key => {
            delete this[key];
        });
        this.current = null;
    };
}

module.exports = Stack;
